<template>
  <DashboardCard class="tw-pb-4">
    <template #title>
      <WdsStack direction-column gap-sm>
        {{ title }}
        <WdsText secondary :text="subtitle" />
      </WdsStack>
    </template>
    <div v-if="loading" class="loading-list">
      <LoadingList :count="3" />
    </div>
    <WdsStack v-else-if="isEmpty" justify-center class="tw-p-1">
      <WdsText small secondary>{{ emptyText }}</WdsText>
    </WdsStack>
    <WdsStack v-else gap-sm direction-column>
      <template v-for="(section, index) in visibleSections">
        <WdsStack v-if="section.items.length > 0" :key="index" gap-sm direction-column>
          <WdsText
            v-if="section.label"
            secondary
            class="tw-font-bold tw-capitalize"
            :text="section.label"
          />
          <BaseList class="clients-list">
            <slot v-for="item in section.items" :key="item.id" name="row" :item="item" />
          </BaseList>
        </WdsStack>
      </template>
    </WdsStack>
  </DashboardCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsStack, WdsText } from '@worksome/wds-components'
import DashboardCard from '@/components/Dashboard/DashboardCard.vue'
import BaseList from '@/components/BaseList.vue'
import LoadingList from '@/components/Dashboard/Widgets/Utils/LoadingList.vue'

export interface ClientSection<T extends { id: string } = { id: string }> {
  label?: string
  items: T[]
}

const props = defineProps<{
  title: string
  subtitle: string
  emptyText: string
  loading: boolean
  sections: ClientSection[]
}>()

const visibleSections = computed(() =>
  props.sections.filter((s) => s.items.length > 0),
)

const isEmpty = computed(() => visibleSections.value.length === 0)
</script>

<style scoped>
.clients-list {
  @apply tw-max-h-80 tw-overflow-y-auto;
}
</style>
